module.exports = __webpack_public_path__ + "img/icon-zhanlue.1d2613c5.png";